import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LEADS_BENCHMARK_REDUCER_NAME } from '../constants';

export const LeadsBenchmarkLeadsActionTypes = {
  GET_LEADS_DATA_SUCCESS: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Leads] SUCCESS`,
  GET_LEADS_DATA_ERROR: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} Leads] ERROR`,
};

/**
 * @typedef {string|number} LeadsBenchmarkTableItem
 * @property {string} LABEL "label"
 * @description label for leads e.g. 'Gesamt', 'Telefon-Leads', etc.
 *
 * @property {number} FINANCIAL_INTEREST_LABEL "financialInterestLabel"
 * @description label for leads with financial interest label e.g. 'mit Finanzierungsinteresse'
 *
 * @property {number} LEADS_COUNT "leadsCount"
 * @description # of leads
 *
 * @property {number} LEADS_COUNT_CHANGE "leadsCountChange"
 * @description increase/decrease of leads since the previous time division
 *
 * @property {number} LEADS_FINANCIAL_INTEREST_COUNT "leadsFinancialInterestCount"
 * @description # of leads with financial interest
 *
 * @property {number} LEADS_FINANCIAL_INTEREST_COUNT_CHANGE "leadsFinancialInterestCountChange"
 * @description increase/decrease of leads with financial interest since the previous time division
 */

export const LEADS_BENCHMARKTABLE_TABLE = {
  LABEL: 'label',
  FINANCIAL_INTEREST_LABEL: 'financialInterestLabel',
  LEADS_COUNT: 'leadsCount',
  LEADS_COUNT_CHANGE: 'leadsCountChange',
  LEADS_FINANCIAL_INTEREST_COUNT: 'leadsFinancialInterestCount',
  LEADS_FINANCIAL_INTEREST_COUNT_CHANGE: 'leadsFinancialInterestCountChange',
};

/**
 * @typedef {'total'|'phone'|'email'|'chat'} LeadsType
 */
export const LEADS_BENCHMARK_LEAD_TYPES = {
  TOTAL: 'total',
  PHONE: 'phone',
  EMAIL: 'email',
  CHAT: 'chat',
};

/**
 * @constant LEADS_PREFIX
 * @description
 * feature cache key prefix
 */
export const LEADS_PREFIX = 'leads';
